
import { IDataTableColumn } from "src/classes";
import Vue from "vue";

export default Vue.extend({
	props: {
		column: {
			type: Object as ()=>IDataTableColumn,
			required: true
		},
		item: {
			type: Object as ()=>any
		},
		width: {
			type: String,
		},
		rootStyle: {
			type: Object as any,
			default: ()=>{
				return {};
			}
		}
	},
	computed: {
		resolvedProperty():any{
			let highestObj = this.item;
			let lowestObj = this.item;
			let obj = this.item;
			if (this.column.getValueFunc){
				obj = this.column.getValueFunc(this.item);
			}else{
				let pathParts = this.column.property.split(".");
				for (let part of pathParts) {
					if (obj == null) {
						return "";
					}
					lowestObj = obj;
					obj = obj[part];
				}
			}
			if (this.column.print) {
				return this.column.print(obj, highestObj, lowestObj);
			}
			return obj;
		},
		cursorStyle():string | undefined{
			if (this.column.click || this.column.dblClick){
				return "pointer";
			}
			return undefined;
		},
		classes():string{
			let result = {} as any;
			if (this.column.classes) {
				for (let c of this.column.classes) {
					result[c] = true;
				}
			}
			result.right = this.column.right;
			result.center = this.column.center;
			return result;
		},
		style():any{
			if (this.column.getStyle){
				let style = this.column.getStyle(this.item);
				return {
					...this.rootStyle,
					...style
				};
			}
			return this.rootStyle;
		}
	},
	methods: {
		onColTapTouch(event:Event){
			event.stopPropagation();
			event.preventDefault();
			if (this.column.click) {
				this.$emit("column-click", this.column, event);
			}else{
				this.$emit("tap-touch", event);
			}
		},
		onColumnDoubleClick(event:Event){
			if (!this.column.dblClick) return;
			event.stopPropagation();
			event.preventDefault();
			this.column.dblClick(this.item);
		}
	}
});
